import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  customerEvents: [],
  loading: false,
  error: null,
  customerChargingHistory: [],
  customerLoading: false,
  customerError: null,
  stationChargingHistory: [],
  stationLoading: false,
  stationError: null,
};

const customerEventsSlice = createSlice({
  name: "customerEvents",
  initialState,
  reducers: {
    fetchCustomerEventsSuccess: (state, action) => {
      state.loading = false;
      state.customerEvents = action.payload;
    },
    fetchCustomerEventsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchCustomerChargingHistorySuccess: (state, action) => {
      state.customerLoading = false;
      state.customerChargingHistory = action.payload;
    },
    fetchCustomerChargingHistoryFailure: (state, action) => {
      state.customerLoading = false;
      state.customerError = action.payload;
    },
    fetchStationChargingHistorySuccess: (state, action) => {
      state.stationLoading = false;
      state.stationChargingHistory = action.payload;
    },
    fetchStationChargingHistoryFailure: (state, action) => {
      state.stationLoading = false;
      state.stationError = action.payload;
    },
  },
});

export const {
  fetchCustomerEventsFailure,
  fetchCustomerEventsSuccess,
  fetchCustomerChargingHistoryFailure,
  fetchCustomerChargingHistorySuccess,
  fetchStationChargingHistoryFailure,
  fetchStationChargingHistorySuccess,
} = customerEventsSlice.actions;

export default customerEventsSlice.reducer;
